export interface User {
  id: number;
  email: string;
  name: string | null;
  first_name: string | null;
  last_name: string | null;
  tenant_id: number;
  country: string | null;
  locale: string | null;
  email_verified: boolean;
}

export interface SignUpParams {
  email: string;
  password: string;
  password_confirmation: string;
  name: string;
  country: string;
  phone?: string;
  terms_accepted: boolean;
}

export interface SignInParams {
  email: string;
  password: string;
}

export class AuthError extends Error {
  error?: string;
  fieldErrors?: Record<string, string[]>;

  constructor(fields: { error?: string; fieldErrors?: Record<string, string[]> }) {
    super(fields.error ?? 'Authentication failed');
    this.error = fields.error;
    this.fieldErrors = fields.fieldErrors;
  }
}

export interface Plan {
  id: number;
  name: string;
  schedule_cost_cents: number | null;
  currency: string;
  guided_preparation: boolean;
}
